import React from 'react';
import { Phone, FileText, CheckCircle } from 'lucide-react';
import { howToOrderSteps } from '../data/mockData';

const iconMap = {
  Phone: Phone,
  FileText: FileText,
  CheckCircle: CheckCircle
};

const HowToOrder = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            How to <span className="text-primary">Order</span>
          </h2>
          <p className="text-xl text-gray-600">
            Simple 3-step process to get your fabrics
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {howToOrderSteps.map((step, index) => {
            const IconComponent = iconMap[step.icon];
            return (
              <div
                key={step.step}
                className="relative"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* Connection Line */}
                {index < howToOrderSteps.length - 1 && (
                  <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-primary to-accent"></div>
                )}

                <div className="step-card text-center">
                  {/* Step Number Badge */}
                  <div className="relative inline-block mb-6">
                    <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center shadow-lg">
                      <IconComponent size={36} className="text-white" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-10 h-10 bg-accent rounded-full flex items-center justify-center text-white font-bold shadow-md">
                      {step.step}
                    </div>
                  </div>

                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-12">
          <p className="text-lg text-gray-700 mb-6">
            Ready to place your order? Contact us now!
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="tel:919713889720"
              className="btn-primary btn-lg flex items-center gap-2"
            >
              <Phone size={20} />
              +91 9713889720
            </a>
            <a
              href="https://wa.me/919713889720?text=Hello%2C%20I%20want%20to%20place%20an%20order"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary btn-lg flex items-center gap-2"
            >
              <Phone size={20} />
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToOrder;
